import RegionalComparisonModel from '../../model/regionalComparisonModel';
import AppStateModel from '../../../../model/appStateModel';
import ContentModel from '../../../../model/contentModel';
import MainController from '../../../../controller/MainController';
import ViewportUtility from '@/core/utils/viewport/viewportUtil';
import HelperUtil from './../../../../../core/utils/helperUtil';
import LogUtil from './../../../../../core/utils/logUtil';
import styles from './eastwest.module.scss';
import template from './eastwest.tpl';
import {gsap} from 'gsap';
import map from '@/assets/icons/deutschland_map.svg?raw';
import male from '@/assets/images/male.svg?raw';
import female from '@/assets/images/female.svg?raw';

// dropdown template
import ddTemplate from '@/app/components/templates/dropdown/dropdown.tpl';
import ddStyles from '@/app/components/templates/dropdown/dropdown.module.scss';
import arrow from '@/assets/icons/dropdown-grey.svg?raw';
import Tooltip from '@/app/components/tooltip/tooltip';

const _SVG_EAST_SELECTOR = '#Thüringen, #Sachsen, #Sachsen-Anhalt, #Brandenburg, #Berlin, #Mecklenburg-Vorpommern'

let selectionHandler: ((event:Event) => void) | null = null;
export default class EastWest {

    public _id:string = 'eastwest'
    private data:any
    private common:any
    private template:string
    private west_average:any
    private east_average:any
    private map:HTMLElement|null = null
    private map_east:NodeListOf<HTMLElement>|null = null
    private label_west:NodeListOf<HTMLElement>|null = null
    private label_east:NodeListOf<HTMLElement>|null = null
    private selection:HTMLElement|null = null
    private birthyear_selection:HTMLSelectElement|null = null
    private target:HTMLElement|null = null;

    constructor(data) {


        this.data = data;
        this.common = ContentModel.instance.getCommonData();
        this.template = template({
            data: data,
            styles: styles,
            default: this.common.defaults.input,
            svg: {
                map: map,
                male: male,
                female: female
            },
            dropdown: ddTemplate({
                styles: ddStyles,
                icon: arrow,
                options: HelperUtil.getInterval(this.common.limits.birthyear.min_year, this.common.limits.birthyear.max_year),
                default: this.common.defaults.input,
            })
        });

        selectionHandler = (event) => this.setAverages(event);

        // EventDispatcher.addEventListener(ViewportEvent.BREAKPOINT_CHANGE, (event) => this.breakPointChange(event));
    }

    init() {

        if (!this.birthyear_selection) {
            return
        }

        if (selectionHandler) {
            this.birthyear_selection.addEventListener('change', selectionHandler);
        }


        // set selection/result values if present (chosen in a previous view)
        if (AppStateModel.birthday) {

            this.birthyear_selection.value = AppStateModel.birthday;

            const values = RegionalComparisonModel.averagesMap[AppStateModel.birthday];
            this.update(values);
        }
    }

    /*breakPointChange(event) {
        // react on change if needed
    }*/

    setAverages(event) {

        let values;
        if (event.target.value === this.common.defaults.input) {

            values = {
                west: {m: this.common.defaults.input, w: this.common.defaults.input},
                east: {m: this.common.defaults.input, w: this.common.defaults.input}
            }
        } else {

            AppStateModel.birthday = event.target.value;

            values = RegionalComparisonModel.averagesMap[event.target.value];
        }

        this.update(values);
    }

    update(values) {



        let values_averages = [
            this.west_average.male,
            this.west_average.female,
            this.east_average.male,
            this.east_average.female
        ];

        // first hide and slide values
        function hideValues(onComplete) {

            gsap.to(values_averages, 0.2, {top: 10, autoAlpha: 0, onComplete: onComplete});
        }

        // then change before revealing values again
        function showValues() {
            setValues();
            gsap.fromTo(values_averages, 0.2, {css: {top: -10, autoAlpha: 0}}, {css: {top: 0, autoAlpha: 1}});
        }

        function setValues() {

            values_averages[0].textContent = values.west.m;
            values_averages[1].textContent = values.west.w;

            values_averages[2].textContent = values.east.m;
            values_averages[3].textContent = values.east.w;
        }

        hideValues(() => showValues());

        // enable sharing for this view/step when values are present
        MainController.setSharing(true);
    }

    show(timeline, previousStep) {

        let timelineGroup = [
            gsap.from(['.step > h1', '.legend'], 0.2, {autoAlpha: 0, y: -20}),
            gsap.from(this.label_west, 0.2, {x: 300, y: -18, width: 0, autoAlpha: 0}),
            gsap.from(this.label_east, 0.2, {x: -300, y: -18, width: 0, autoAlpha: 0})
            // adding tween animations here depending on which step comes next.
        ];

        // only add detail animations if we are above mobile widths.
        if (ViewportUtility.width >= 1024) {
            switch (previousStep) {

                case 'regional':
                    break;

                case 'index':
                    timelineGroup.push(gsap.from(this.selection, 0.2, {x: -150}));
                    break;

                default:
                    break;
            }
        }

        timeline.add(timelineGroup);
    }

    hide(timeline, nextStep, onComplete) {

        let timelineGroup = [
            gsap.to(['.step > h1', '.legend'], 0.2, {autoAlpha: 0, onComplete: onComplete})
            // adding tween animations here depending on which step comes next.
        ];

        // only add detail animations if we are above mobile widths.
        if (ViewportUtility.width >= 1024) {
            switch (nextStep) {

                case 'regional':
                    timelineGroup.push(gsap.to(this.label_east, 0.2, {x: -300, y: -18, width: 0, autoAlpha: 0}));
                    timelineGroup.push(gsap.to(this.label_west, 0.2, {x: 300, y: -18, width: 0, autoAlpha: 0}));
                    timelineGroup.push(gsap.to(this.map_east, 0.2, {fill: '#b6c0c5'}));
                    timelineGroup.push(gsap.to(this.map, 0.2, {
                        x: -76,
                        y: -18,
                        width: 243,
                        height: 324.42
                    }));
                    break;

                case 'index':
                    LogUtil.warn('No animation for transition, fall back to default');
                // TODO, if we can navigate back to index from within this step we should add animations for that.
                //break;

                default: // eslint-disable-line
                    // currently without fallback default. Instantly show.
                    break;
            }
        }

        timeline.add(timelineGroup);
    }

    setSVGPatterns() {
        let patternID = this.common.layout.pattern_east_germany_id
        if (patternID) {
            this.map_east?.forEach((element: HTMLElement) => {
                element.style.fill = `url(#${patternID})`;
                element.style.stroke = this.common.colors['icon-dark'];
                element.style.strokeWidth = '0.75px';

                // render order, design/asset specific for having the black borders of east states render above west states (no stroke)
                element.parentNode?.appendChild(element)
            });

            this.target?.querySelector('#step_eastwest .east')?.classList.add('pattern');
        }
    }

    appendTo(target) {
        this.target = target;

        if (!this.target) {
            return
        }

        this.target.setAttribute('id', this.data.steps.eastwest.id);
        this.target.innerHTML = this.template;

        this.map = this.target.querySelector('.map');
        this.map_east = this.target.querySelectorAll(_SVG_EAST_SELECTOR);
        this.setSVGPatterns();
        // Collect DOM references

        // used by animations
        this.label_west = this.target.querySelectorAll('div.west');
        this.label_east = this.target.querySelectorAll('div.east');
        this.selection = this.target.querySelector('div.selection');

        // needed for functionality
        this.birthyear_selection = this.target.querySelector('.dropdown > select');
        this.west_average = {
            male: this.target.querySelector('.west > p > .male'),
            female: this.target.querySelector('.west > p > .female'),
        };
        this.east_average = {
            male: this.target.querySelector('.east > p > .male'),
            female: this.target.querySelector('.east > p > .female'),
        };

        const tooltip = new Tooltip(this.data.source_tooltip.link,this.data.source_tooltip.headline,
            this.data.source_tooltip.text );
        tooltip.appendTo(this.target.querySelector('div.source_tooltip'));
    }
}
